import React from 'react';
import Shimmer from '../../../core/Shimmer/Shimmer';
import ShimmerWrapper from '../../../core/Shimmer/ShimmerWrapper';

const SalarySkeleton = ({}) => {
    return (
        <ShimmerWrapper spacing={20}>
            <ShimmerWrapper direction='row' align='center' spacing={8}>
                <Shimmer width='120px' height={16} />
                <Shimmer circle size={16} />
            </ShimmerWrapper>

            <ShimmerWrapper spacing={20} border borderRadius={8} padding={20}>
                <ShimmerWrapper direction='row' spacing={16} align='center'>
                    <Shimmer width='320px' height={40} radius={8} />
                    <Shimmer width='140px' height={40} radius={8} />
                    <Shimmer width='140px' height={40} radius={8} />
                    <Shimmer width='140px' height={16} />
                </ShimmerWrapper>

                <ShimmerWrapper direction='row' spacing={12} align='flex-start'>
                    <Shimmer width='42px' height='24px' radius='20px' />

                    <ShimmerWrapper spacing={8} flex={1}>
                        <Shimmer width='420px' height={16} />
                        <Shimmer width='100%' height={14} />
                        <Shimmer width='90%' height={14} />
                    </ShimmerWrapper>
                </ShimmerWrapper>
            </ShimmerWrapper>
        </ShimmerWrapper>
    );
};

export default React.memo(SalarySkeleton);
